module.exports = __webpack_public_path__ + "img/Icon-Send.c41ff943.svg";